import clsx from 'clsx';
import { useFitText } from '@flyyer/use-fit-text';
import { FitEconomizeProps } from '.';
import { useEffect, useState } from 'react';

export default function FitEconomizePrimary({
  width,
  height,
  matrix = [0, 0, 0, 0, 0, 0, 0],
  text,
  top = 0,
  left = 0,
  right,
  color = [0, 0, 0],
  textAlign = 'center',
  whiteSpace = 'normal',
  background: [r, g, b, a] = [0, 0, 0, 0],
  padding = '0',
  rotate = 0,
  fontFamily = '"Primary"',
  fontWeight = 'normal',
  alignItems,
  justifyContent,
}: FitEconomizeProps) {
  const [refresh, setRefresh] = useState(false);
  const isRight = right !== undefined ? true : false;
  const { ref, fontSize, isCalculating } = useFitText(
    {
      maxFontSize: 1000,
      resolution: 10,
    },
    [width, height, text, refresh],
  );
  useEffect(() => {
    const timer = setInterval(() => {
      clearInterval(timer);
      setRefresh(!refresh);
    }, 1000);
  }, []);
  const className = clsx({ 'flyyer-wait': isCalculating });
  return (
    <div
      style={{
        transition: 'transform 500ms',
        transformOrigin: `${isRight ? 'right' : 'left'} top`,
        transform: `matrix(${matrix.join(', ')})`,
      }}
    >
      <div
        ref={ref}
        style={{
          position: 'absolute',
          display: 'flex',
          transition: 'height 500ms, top 500ms, left 500ms, right 500ms',
          transformOrigin: '0 50%',
          transform: `rotate(-${rotate}rad)`,
          top,
          ...(() => (isRight ? { right: right } : { left: left }))(),
          fontSize,
          fontFamily,
          fontWeight,
          letterSpacing: '0.1px',
          height,
          width,
          color: `rgb(${color[0]},${color[1]},${color[2]})`,
          textAlign,
          whiteSpace,
          background: `rgb(${r}, ${g}, ${b}, ${a})`,
          padding,
          alignItems,
          justifyContent,
          backgroundImage: `url(/economize.png)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: ' no-repeat',
        }}
        className={className}
      >
        {text ? (
          <span
            style={{
              padding: '30% 15% 15% 15%',
            }}
          >
            {text}
          </span>
        ) : null}
      </div>
    </div>
  );
}
